<template>
    <div>
        <ol v-if="decimal || parentheses" :class="classObject">
            <slot></slot>
        </ol>
        <ul v-else :class="classObject">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "ListText",
        props: {
            /**
             * 赤テキストにするか
             */
            caution: {
                type: Boolean,
                default: false
            },
            /**
             * 小さいテキストにするか
             */
            comments: {
                type: Boolean,
                default: false
            },
            /**
             * マーカーを消すか
             */
            none: {
                type: Boolean,
                default: false
            },
            /**
             * 先頭マーカーを1., 2.にするか
             */
            decimal: {
                type: Boolean,
                default: false
            },
            /**
             * 先頭マーカーを(1), (2)にするか
             */
            parentheses: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                ulClass: null
                }
        },
        computed: {
            // computedでclassのobjectを持てる
            classObject() {
                return {
                    'm-list-text': true,
                    'm-list-text_caution': this.caution,
                    'm-list-text_comments': this.comments,
                    'm-list-text_none': this.none,
                    'm-list-text_decimal': this.decimal,
                    'm-list-text_parentheses': this.parentheses
                }
            }
        }
    }
</script>
